<template>
  <ul 
    class="submenu" 
    :class="mode"
  >
    <div
      v-for="link in links"
      :key="link.ruta" 
      class="nav-sub-item"
      :class="[linksMode, link.mode]"
      :style="[isMovil ? link.style : '' ]"  
      @click="$emit('close-menu',link)"
    >       
      <a 
        v-if="link.fullpath"
        :href="link.ruta"
      >
        <font-icon 
          v-if="link.icon" 
          :icon="link.nombre"        
        />
        <span v-else>
          {{ link.nombre }}
        </span>
      </a>  
      <router-link 
        v-if="!link.fullpath"
        :to="link.ruta"
      >
        <font-icon 
          v-if="link.icon" 
          :icon="link.nombre"        
        />
        <span v-else>
          {{ link.nombre }}
        </span>
      </router-link>   
    </div>
  </ul>
</template>

<script>
export default {
  props: {
    links: {
      type: Array,
      requiered: true,   
      default: () => []  
    },
    mode: {
      type: String,
      requiered: false, 
      default: ""  
    },
    linksMode: {
      type: String,
      requiered: false, 
      default: ""  
    },
  },
  emits: ['close-menu'],
  computed: {
    isMovil() {
      return this.$store.getters.getMovilView
    },

  },
}
</script>

<style scoped>

</style>
